const checkValuesInNewTimeLog = (data, setFlag) => {
  const badEntries = data
    .map((entry) => entry.timeSpent)
    .map((value) => value * 10)
    .filter((entry) => entry % 5 !== 0);
  if (badEntries.length > 0) {
    setFlag(false);
  } else {
    setFlag(true);
  }
};

export default checkValuesInNewTimeLog;
